import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import moment from 'moment';
import { CommonService } from '../../../../services/common/common.service';
import { ClicksDataService, ClicksColumnsService } from '../../../services';
import { Click, ClicksResult } from '../../../interfaces';

@Component({
  selector: 'app-click-form',
  templateUrl: './click-form.component.html',
  styleUrls: ['./click-form.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class ClickFormComponent implements OnInit, OnDestroy, AfterViewInit {

  public click: Click = {};
  public clickForm: FormGroup = new FormGroup({});
  public clicks: Click[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public redirect = true;
  public disableSubmit = false;
  public enableFormAlert = true;


  constructor(
    private translate: TranslateService,
    public common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private clicksDataService: ClicksDataService,
    public clicksColumnsService: ClicksColumnsService,
  ) {
  }

  ngOnInit(): void {
    console.log('ngOnInit', 'ClickFormComponent');
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Click - Edit');
        this.getClick(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.click !== 'undefined') {
      this.click = this.dynamicDialogConfig.data.click;
    }
    if (typeof this.click.id === 'undefined' || this.click.id === null) {
      this.click.id = null;
    }
    this.getClicks();
    this.prepareFrom();
  }

  ngOnDestroy(): void {
    console.log('ngOnDestroy', 'ClickFormComponent');
  }

  ngAfterViewInit(): void {
    console.log('ngAfterViewInit', 'ClickFormComponent');
  }

  getClick(id: number): void {
    this.isLoading = true;
    this.clicksDataService.getClick(id).subscribe((response: Click|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.click = response;
        this.prepareFrom();
      }
    });
  }

  getClicks(): void {
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.clicks !== 'undefined' && this.dynamicDialogConfig.data.clicks.length > 0) {
      this.clicks = this.dynamicDialogConfig.data.clicks;
      return;
    }
    this.clicksDataService.getClicks(this.parameters).subscribe((response: ClicksResult|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.clicks = response.results;
      }
    });
  }

  prepareFrom(): void {
    this.clickForm = new FormGroup({
      id: new FormControl(this.click.id, []),
      visit: new FormControl((typeof this.click.visit === 'number') ? this.click.visit : this.click.visit?.id, []),
      banner: new FormControl((typeof this.click.banner === 'number') ? this.click.banner : this.click.banner?.id, [Validators.required, ]),
    });
  }

  list() {
    this.router.navigate(['/clicks']);
  }

  showErrors() {
      this.showErrors();
      const invalidFields: string[] = [];
      Object.keys(this.clickForm.controls).forEach((field: any) => {
        const control = this.clickForm.get(field);
        if (control !== null) {
          control.markAsTouched({ onlySelf: true });
          if (control.invalid) {
            invalidFields.push(field);
          }
        }
      });
  }

  submitForm(redirect: boolean) {
    this.redirect = redirect;
    if (!this.clickForm.valid) {
      this.showErrors();
    } else {
      this.saveData(redirect);
    }
  }

  saveData(redirect: boolean) {
    this.click = this.clickForm.value;
    this.disableSubmit = true;
    console.log('click', this.click);
    if (typeof this.click.id !== 'undefined' && this.click.id !== null) {
      this.add(redirect);
    } else {
      this.update(redirect);
    }
    return false;
  }

  add(redirect: boolean) {
    this.clicksDataService.updateClick(this.click).subscribe((data: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('CLICKUPDATED')});
      if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
        this.dynamicDialogRef.close({refresh: true});
      } else if (redirect) {
        this.list();
      }
    }, (error: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('CLICKNOTUPDATED') + ' ' + error.message});
      console.warn(error);
    });
  }

  update(redirect: boolean) {
    this.clicksDataService.addClick(this.click).subscribe((data: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('CLICKCREATED')});
        if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
          this.dynamicDialogRef.close({refresh: true});
        } else if (redirect) {
          this.list();
        }
      }, (error: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('CLICKNOTCREATED') + ' ' + error.message});
        console.warn(error);
    });
  }

}

@Component({
  selector: 'app-click-form',
  templateUrl: './click-form.component.html',
  styleUrls: ['./click-form.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogClickFormComponent extends ClickFormComponent {
}

